import React, { Component } from "react";
import { HashLink as Link } from 'react-router-hash-link';

class Footer extends Component {
    render() {
        return (
            <>
                <footer className="footer section bg-cover overlay-dark pt-60" id="ContactUs">
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-xl-5 mt-40">
                                <img className="mb-25" src={process.env.PUBLIC_URL + '/assets/images/logoFiorentina.png'} alt="" />
                                
                                <p className="text-gray">Fiorentina Baseball S.S.D. a R.L.</p>
                                <p className="text-gray">Società Sportiva Dilettantistica a Responsabilità Limitata</p>
                                <p className="text-gray"><a rel="noopener noreferrer" href="https://what3words.com/fagiani.omaggio.voluto" target="_blank">V.le M. Fanti, 18 – I 50137 Firenze</a></p>
                                <p className="text-gray">Cod. Fiscale e P. I.V.A.: 04698780485</p>
                                <p className="text-gray">Nr. Iscr. REA C.C.I.A.A. FI-472158</p>
                                <p className="text-gray">PEC: fiorentinabaseball@pec.net</p>
                                <p className="text-gray">Iscr. FIBS: 09001 - Iscr. CONI: 24663</p>
                                
                                <ul className="social-links list-unstyled mt-25">
                                    <div>
                                        <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/FiorentinaBaseball"><span className="icon fab fa-facebook-f  col-4" /></a>
                                        <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UCBer3-yW7f3w1kUV1XbluZw"><span className="icon fab fa-youtube  col-4" /></a>
                                        <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/fiorentinabaseballsoftball"><span className="icon fab fa-instagram col-4" /></a>
                                        <a target="_blank" rel="noopener noreferrer" href="https://w3w.co/fagiani.omaggio.voluto"><span className="icon fas fa-home col-4" /></a>
                                    </div>
                                </ul>
                            </div>
                            <div className="col-xl-3 col-md-6 mt-40">
                                <h4 className="font-w-600 text-white mb-10">Get in touch</h4>
                                <div className="text-gray mt-20">
                                    <a href="tel: +39 370 362 9236" target="_blank"><span className="icon text-primary fas fa-phone-alt mr-2" />
                                    +39 370 362 9236 </a>
                                </div>
                                <div className="text-gray mt-20">
                                    <a href="mailto:info@fiorentinabaseball.it" target="_blank"><span className="icon text-primary fas fa-envelope mr-2" />
                                    info@fiorentinabaseball.it </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <div className="footer-bottom overlay-dark">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <p>Copyright © 2021 Fiorentina Baseball</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Link to="#top" className="scroll-to-top">
                    <span className="fas fa-chevron-up" />
                </Link>
            </>
        );
    }
}

export default Footer;